"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.discountsFactory = exports.discountFactory = void 0;
var discountFactory = function (gqlDiscount) {
    var _a, _b, _c;
    return ({
        id: gqlDiscount.id,
        range: {
            start: new Date((_a = gqlDiscount.range) === null || _a === void 0 ? void 0 : _a.start),
            end: new Date((_b = gqlDiscount.range) === null || _b === void 0 ? void 0 : _b.end),
        },
        discount: gqlDiscount.discount,
        recurrenceId: (_c = gqlDiscount.recurrence) === null || _c === void 0 ? void 0 : _c.id,
        resourceId: gqlDiscount.resourceId,
    });
};
exports.discountFactory = discountFactory;
var discountsFactory = function (gqlDiscounts) {
    return gqlDiscounts === null || gqlDiscounts === void 0 ? void 0 : gqlDiscounts.map(function (discount) { return discountFactory(discount); });
};
exports.discountsFactory = discountsFactory;
